import React from 'react';
import { Link } from 'react-router-dom';

interface HubCardProps {
  image: string;
  title: string;
  tag: string;
  desc: string;
  items: string[];
  to: string;
  cta: string;
  btn: 'btn-blue' | 'btn-orange';
  tint?: string;
}

const HubCard: React.FC<HubCardProps> = ({ image, title, tag, desc, items, to, cta, btn, tint = '#EFF6FF' }) => (
  <div
    style={{ position: 'relative', overflow: 'hidden', display: 'flex', flexDirection: 'column', border: '2px solid var(--gray-200)', borderRadius: '20px', padding: '16px 20px 18px', background: `linear-gradient(180deg, ${tint} 0, #fff 118px)`, transition: '.2s' }}
    onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--blue-light)'; e.currentTarget.style.boxShadow = 'var(--shadow-md)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--gray-200)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
  >
    <img
      src={image}
      alt=""
      aria-hidden="true"
      style={{ position: 'absolute', top: 8, right: 10, width: '54%', height: 'auto', pointerEvents: 'none' }}
    />
    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', flex: 1 }}>
      <div style={{ maxWidth: '45%', minHeight: '88px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <h2 style={{ fontSize: '1.1rem', fontWeight: 800, margin: '0 0 3px', color: 'var(--gray-800)', lineHeight: 1.25 }}>{title}</h2>
        <p style={{ color: 'var(--orange)', fontWeight: 700, fontSize: '.76rem', margin: 0, lineHeight: 1.35 }}>{tag}</p>
      </div>
      <p style={{ color: 'var(--gray-600)', fontSize: '.84rem', lineHeight: 1.55, margin: '10px 0 8px' }}>{desc}</p>
      <ul style={{ paddingLeft: '18px', margin: '0 0 14px', color: 'var(--gray-600)', fontSize: '.82rem', lineHeight: 1.5 }}>
        {items.map((i) => <li key={i} style={{ marginBottom: '2px' }}>{i}</li>)}
      </ul>
      <div style={{ marginTop: 'auto' }}>
        <Link to={to} className={`btn ${btn} btn-sm btn-full`} style={{ display: 'block', textAlign: 'center' }}>{cta}</Link>
      </div>
    </div>
  </div>
);

export default HubCard;
